export class EventBus {
	constructor() {
		this.events = new Map();
	}

	on(event, callback) {
		if (!this.events.has(event)) {
			this.events.set(event, []);
		}
		this.events.get(event).push(callback);

		return () => this.off(event, callback);
	}

	off(event, callback) {
		const callbacks = this.events.get(event);
		if (callbacks) {
			const index = callbacks.indexOf(callback);
			if (index > -1) {
				callbacks.splice(index, 1);
			}
		}
	}

	emit(event, data) {
		const callbacks = this.events.get(event);
		if (callbacks) {
			callbacks.forEach((callback) => {
				try {
					callback(data);
				} catch (error) {
					console.error('[FeedbackSDK] Event callback error:', error);
				}
			});
		}
	}

	once(event, callback) {
		const unsubscribe = this.on(event, (data) => {
			callback(data);
			unsubscribe();
		});
		return unsubscribe;
	}

	clear() {
		this.events.clear();
	}

	getListenerCount(event) {
		const callbacks = this.events.get(event);
		return callbacks ? callbacks.length : 0;
	}
}
